import { useMemo, useEffect, useRef, useState } from 'react';
import { useUserAuth } from '../context/UserAuthContext';
import { MdArrowForwardIos, MdArrowBackIos } from 'react-icons/md';
import { GET_BANNER_SERVICE } from '../services/bannerService';
import styles from '../styles/SlideShow.module.css';
import { useProducts } from '../context/ProductsContext';
import { useNavigate } from 'react-router-dom';
import { isImage, isVideo } from '../utils/typeOfUrl';
import { VideoBanner } from './VideoBanner';
import Carousel from 'react-multi-carousel';
import { Modal, Box } from '@mui/material';

import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuCarrusel from './MenuCarrusel';

const items = [
  {
    title: 'Calcular mi ganancia',
    code: 'CALCULADORA',
    description: '',
    titlepopup: '¿Ganas lo que deberías?',
  },
  {
    title: '¿A cómo vender?',
    code: 'AYUDA',
    description: '12,000 colegas te ayudaran',
    titlepopup: '',
  },
  {
    title: 'Teléfonos de Emergencia',
    code: 'EMERGENCIA',
    description:'',
    titlepopup: 'Teléfonos de Emergencia',
  },
  {
    title: '¡Mi historia!',
    code: 'HISTORIA',
    description:'Casos reales de bodegueros',
    titlepopup: '',
  },
  {
    title: '¡Mis Caseritos',
    code: 'CASERITOS',
    description:'Registra, promociona y vende',
    titlepopup: '',
  },
];

const whiteLogos = [
  '/assets/Dinero.png',
  '/assets/Pensando.png',
  '/assets/Sirena.png',
  '/assets/Libro.png',
  '/assets/Caseritos.png',
];

const SlideShow = () => {
  const slideshow = useRef(null);
  const { user } = useUserAuth();
  const { products, setSearchProducts, setFilteredProducts, setSearch, banners } = useProducts();
  const navigate = useNavigate();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

const responsiveProduct = {
  desktop: {
    breakpoint: { max: 3000, min: 1000 },
    items: 4,       // Muestra 4 items completos en desktop
    partialVisibilityGutter: 0
  },
  tablet: {
    breakpoint: { max: 1000, min: 600 },
    items: 3,       // Muestra 3 items completos en tablet
    partialVisibilityGutter: 30
  },
  mobile: {
    breakpoint: { max: 600, min: 320 },
    items: 2,       // Muestra 2 items (parcialmente visibles) en móvil
    partialVisibilityGutter: 0  // Espacio adicional para indicar que hay más contenido
  }
};


  const handleClickBanner = (ids) => {
    const newProducts = ids
      .map((id) => {
        return products.filter((product) => product.code === id);
      })
      .flat();

    if(newProducts.length === 0) return;

    setSearchProducts(newProducts);
    setFilteredProducts(newProducts);
    setSearch('p');
    navigate('/tienda/busqueda');
  };
  const logos = whiteLogos;

  const PopupStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '80%', md: '500px' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  borderRadius: '8px',
  maxHeight: '80vh',
  overflowY: 'auto'
};

  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => setOpenIndex(index);
  const handleClose = () => setOpenIndex(null);


  return (
    <>
      <div className={styles.container}>
        <Carousel className={styles.container__slideshow} containerClass='banner-carousel' ref={slideshow} autoPlay autoPlaySpeed={8000} responsive={responsive} partialVisbile={false} infinite>
          {banners.topBanners.map((item) => (
            <div key={item.id} className={styles.slide} id={item.id}>
              {isImage(item.imgUrl) ? <img className={styles.slide__img} src={item.imgUrl} alt='' onClick={() => handleClickBanner(item.relatedProductsIds)} /> : ''}

              {isVideo(item.imgUrl) ? (
                <div style={{ width: '100%', maxHeight: '400px' }}>
                  <VideoBanner item={item} />
                </div>
              ) : (
                ''
              )}
              <button className={styles.btn__banners} onClick={() => handleClickBanner(item.relatedProductsIds)}>
                Ver Productos Relacionados
              </button>
            </div>
          ))}
        </Carousel>


{/* <Carousel className={styles.container__slideshow} 
        containerClass="carousel-container"
        ref={slideshow}
        autoPlay
        autoPlaySpeed={4000}
        responsive={responsiveProduct}
        partialVisible={false}  // Asegúrate de que esté en false para centrado
        infinite
        centerMode={true}       // ¡Importante! Activa el modo centrado
        slidesToSlide={1}       // Controla cuántos slides avanzar
        itemClass="carousel-item" // Clase adicional para estilar cada slide
        > */}

        <Carousel 
          autoPlay={true}
          autoPlaySpeed={4000}
          responsive={responsiveProduct}
          partialVisible={true}  // Permite items parcialmente visibles
          infinite={true}
          additionalTransfrom={0}
          itemClass="carousel-item"
          containerClass="carousel-container"
          ssr={true}
          customTransition="transform 300ms ease-in-out"
          draggable={true}
          swipeable={true}
          keyBoardControl={true}
          transitionDuration={500}
          centerMode={false}
          slidesToSlide={1}      // Desliza de 1 en 1 para mejor control
          shouldResetAutoplay={true}
          sliderClass="carousel-slider"
          focusOnSelect={false}
          itemAriaLabel={`Item`}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          dotListClass="carousel-dots"
          arrows={false}         // Opcional: elimina flechas si prefieres
          showDots={true}       // Opcional: elimina dots si prefieres
        >
          {items.map((item, index) => (
            <div 
              key={index} 
              style={{ 
                      padding: '0 5px',
                      cursor: 'pointer' // Cambia el cursor al pasar el mouse
                    }}
                    onClick={() => handleOpen(index)}
            >
              <Grid item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'left',
                  paddingTop: '8px',
                  paddingRight: '0px',
                  paddingBottom: '8px',  
                  paddingLeft: '0px',
                  // width: '150px',
                  // height: '100px',
                  width:  { xs: '150px', sm: '180px', md: '250px' }, 
                  height: { xs: '100px', sm: '120px', md: '140px' }, 
                  flex: '0 0 auto',
                  margin: '0 5px',
                  // boxSizing: 'border-box',
                  //  '&:hover': {
                  //         transform: 'scale(1.02)',
                  //         transition: 'transform 0.2s ease'
                  //       }
                }}
              >
                <Stack
                  direction='column'
                  component={Card}
                  spacing={0}
                  useFlexGap
                  sx={{
                    p: 1,
                    height: '100%',
                    width: '100%',
                    justifyContent: 'flex-start',
                    alignItems: 'left',
                    backgroundColor: 'white',
                    boxShadow: 3,
                    borderRadius: '8px'
                  }}
                >
                  {/* Contenido igual que antes */}
                  <Box 
                    sx={{
                      width: { xs: '30px', sm: '40px', md: '55px' }, // Tamaño responsive para el icono
                      height: { xs: '30px', sm: '40px', md: '55px' },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}
                  >
                    <img 
                      src={logos[index]} 
                      alt={`Logo ${index + 1}`} 
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                  <Box >
                    <Typography
                      sx={{
                        color: '#212121',
                        fontSize: { xs: '12px', sm: '14px', md: '17px' }, // Tamaño de fuente responsive
                        fontFamily: 'Figerona',
                        fontWeight: '700',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#4D4D4D',
                        fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Tamaño de fuente responsive
                        fontFamily: 'Figerona',
                        fontWeight: '400',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden'
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </div>
          ))}
        </Carousel>

        {items.map((item, index) => (
          <MenuCarrusel 
            open={openIndex === index} 
            onClose={handleClose} 
            title={item.titlepopup} code={item.code}
          />
          ))}
      </div>
    </>
  );
};

export default SlideShow;
